import styled from "styled-components";

export const Container = styled.div``;

//#region Styles History
export const ContentAccordionQuoteHistory = styled.div`
	> .MuiAccordionDetails-root {
		max-height: calc(85vh - 57px - 40px - 27px - 33px - 19px);
	}
`;

export const FooterButtonHistory = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 15px;
	width: 100%;
`;
//#endregion
